<template>
  <div>
    <slotBase :bg-grey="true" :footerRadius="true" fixedFooter>
      <template v-slot:content>
        <div
          class="main p-a-16"
          style="display: flex; align-items: center; height: 90vh"
        >
          <div class="w-100">
            <div class="card-one d-flex">
              <div
                class="card p-0 shadow"
                style="border-radius: 15px; width: -webkit-fill-available"
              >
                <div class="card-header p-0">
                  <div class="sd-heading">
                    <img
                      src="../../../assets/logo.jpg"
                      alt="Profile Picture"
                      class="profile-pic"
                    />
                  </div>
                </div>
                <div class="card-body">
                  <form @submit.prevent="loginUser()">
                    <p class="f-Overpass f-14 f-w-400 m-0">
                      Gunakan nomor <strong>WhatsApp</strong> dan
                      <strong>Kata sandi</strong> untuk masuk ke akun anda.
                    </p>
                    <div class="mb-3">
                      <label
                        for="whatsapp"
                        class="f-Overpass f-14 f-w-400 m-0 f-c-grey"
                        >Nomor WhatsApp <span class="spn-2">*</span></label
                      >
                      <div class="input-group">
                        <span
                          class="input-group-text f-16"
                          id="inputGroup-sizing-sm"
                          >62</span
                        >
                        <input
                          type="number"
                          class="form-control f-16 f-Overpass"
                          id="whatsapp"
                          aria-describedby="whatsapp"
                          placeholder="Masukan Nomor"
                          v-model="noTelp"
                          v-on:input="validationInputTelp"
                        />
                      </div>
                    </div>

                    <div class="mb-3">
                      <label
                        for="password"
                        class="f-Overpass f-14 f-w-400 m-0 f-c-grey"
                        >Kata Sandi <span class="spn-2">*</span></label
                      >
                      <input
                        :type="!btnEye ? 'password' : 'text'"
                        class="input-form-password f-16 p-t-12 p-b-12 f-Overpass"
                        id="password"
                        placeholder="Masukkan Kata Sandi"
                        v-model="passwordUser"
                      />
                      <span
                        toggle="#oldPassword"
                        class="button-eye"
                        @click="btnEyeEvent"
                        ><font-awesome-icon
                          :icon="
                            !btnEye
                              ? 'fa-regular fa-eye'
                              : 'fa-regular fa-eye-slash'
                          "
                          rotation="180"
                          style="color: #6f7287"
                        />
                      </span>
                    </div>
                    <p
                      class="f-Overpass f-14 f-w-400 m-0 f-c-grey d-flex justify-content-end p-t-8 p-x-5"
                      @click="forgotPassword"
                    >
                      Lupa Kata Sandi ?
                    </p>
                    <button type="submit" v-show="false"></button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div class="p-x-24 p-t-16 p-b-16">
          <p class="text-center f-Overpass f-c-grey f-12 f-w-400 m-0">
            Belum punya akun?<button
              type="button"
              class="btn btn-link f-Overpass f-w-600 p-0 text-decoration-none"
              style="font-size: 12px; margin-left: 2px"
              @click="routeToRegester"
            >
              Daftar
            </button>
          </p>
          <button
            type="button"
            class="btn btn-primary w-100 f-Overpass"
            style="font-size: 16px; margin-top: 12px"
            :disabled="btnLogin == false ? false : true"
            @click="loginUser"
          >
            <span
              class="spinner-border text-light f-16 spiner-border-sm"
              v-if="btnLogin"
            ></span>
            <span v-if="!btnLogin">Masuk</span>
          </button>
        </div>
      </template>
    </slotBase>
  </div>
</template>

<script>
import slotBase from "@/components/slots/slotBase.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "loginApp",
  components: {
    slotBase,
  },
  data() {
    return {
      btnEye: false,
      noTelp: "",
      passwordUser: "",
      btnLogin: false,
    };
  },
  computed: {
    ...mapState("auth", {
      dataLogin: "dataLogin",
    }),
  },
  methods: {
    ...mapActions({
      postDataLoginAuth: "auth/postDataLoginAuth",
      getDataDashboard: "dashboard/getDataDashboard",
    }),

    forgotPassword() {
      this.$router.push({ name: "forgotPasswordTelp" });
    },

    validationInputTelp() {
      this.noTelp = this.noTelp.replace(/[^0-9]/g, "");

      const invalidChar = /e-{;'.,|=};.'/;
      if (invalidChar.test(this.noTelp)) {
        this.noTelp = this.noTelp.replace(invalidChar, "");
        return;
      }

      if (this.noTelp.startsWith("62") || this.noTelp.startsWith("0")) {
        this.noTelp = "";
        return;
      }
    },

    btnEyeEvent() {
      if (!this.btnEye) {
        return (this.btnEye = true);
      } else {
        return (this.btnEye = false);
      }
    },

    routeToRegester() {
      this.$router.push({ name: "Register" });
    },

    async loginUser() {
      this.btnLogin = true;
      // console.log("ini no telp & pw " + this.noTelp + " " + this.passwordUser);
      if (this.noTelp !== "" && this.passwordUser !== "") {
        let data = {
          country_code: "62",
          telp: this.noTelp,
          password: this.passwordUser,
        };
        await this.postDataLoginAuth(data).then((res) => {
          // console.log(res);
          if (res.data.status != 200) {
            if (res.data.message !== "password is incorrect") {
              this.$toast.error("Akun tidak ditemukan", { position: "top" });
              this.btnLogin = false;
            } else {
              this.$toast.error(res.data.message, { position: "top" });
              this.btnLogin = false;
            }
          }

          if (res.data.status == 200) {
            // console.log(res.data.data.token);
            const token = localStorage.setItem("token", res.data.data.token);

            if (token !== null) {
              if (localStorage.getItem("token")) {
                this.$toast.success(res.data.message, { position: "top" });
                this.$router.push({ name: "dashboardUtama" });
              }
            }
          }
        });
      } else {
        this.btnLogin = false;
        this.$toast.error("Field masih kosong", { position: "top" });
      }
    },
  },
};
</script>

<style scoped>
.card-one {
  border-radius: 16px;
  background: var(--primary-white, #fff);
  box-shadow: 0px 4px 12px 0px rgba(0, 34, 119, 0.06);
  align-items: center;
  width: -webkit-fill-available;
}

.profile-pic {
  width: 110px; /* Set the width and height of the circular image */
  height: 110px;
  border-radius: 70%; /* Create a circular shape */
  position: absolute; /* Position the image absolutely */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-top: 1%;
  left: 50%; /* Position horizontally at the center */
  transform: translate(-50%, -50%);
}

.sd-heading {
  background-color: #206cfe;
  height: 70px;
  color: #fff;
  align-self: stretch;
  border-radius: 16px 16px 0px 0px;
  background: var(--primary-product-smartlink, #206cfe);
}

/* .spsl-1 {
  color: #206cfe;
  font-size: 16px;
} */

/* .footer {
  width: 100%;
  height: 145px;
  padding: 15px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  gap: 8px;
  background-color: white;
  box-shadow: 0px 4px 12px 0px rgba(0, 34, 119, 0.06);
  position: absolute;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
} */
.spn-2 {
  color: #007bff;
}

.button-eye {
  transform: translateY(30%);
  position: absolute;
  right: 0;
  padding-right: 30px;
}
</style>
